module.exports = __webpack_public_path__ + "img/Article3B.a4b232c8.jpg";